<template>
  <div class="activitiesManage">
    <PageNav :slider="slider" :openMenu="openMenu">
      <el-main>
        <div id="page-activitiesManage">
          <div class="head-tab--nav">
            <div class="head-nav h-3 clearFloat">
              <span class="c-normal">{{ $t("Crmactivemanage.aa") }}</span>
              <div class="pull-right">
                <el-button
                  v-if="postbe_crmlevel == '1' || postbe_crmlevel == '3'"
                  @click="handleCreateClick()"
                  type="warning"
                  >{{ $t("Crmactivemanage.ab") }}</el-button
                >
                <el-button type="primary" @click="daochu">{{
                  $t("Common.btn_export")
                }}</el-button>
              </div>
            </div>
          </div>
          <div class="activitiesManage-container">
            <div class="content">
              <div class="flex-wrap">
                <div class="flex-al mb20 mr10">
                  <span class="mr10 fs14 color-666">{{
                    $t("Crmactivemanage.ac")
                  }}</span>
                  <div class="time-box flex-al">
                    <el-date-picker
                      type="date"
                      :placeholder="$t('Crmactivemanage.ad')"
                      v-model="selectForm.goal_starttime"
                      value-format="yyyy-MM-dd"
                      @change="handleSelect()"
                      style="width: 140px"
                    ></el-date-picker>
                    <span class="ml10 mr10 fs14">{{
                      $t("Crmactivemanage.ae")
                    }}</span>
                    <el-date-picker
                      type="date"
                      :placeholder="$t('Crmactivemanage.af')"
                      v-model="selectForm.goal_endtime"
                      style="width: 140px"
                      value-format="yyyy-MM-dd"
                      @change="handleSelect()"
                    ></el-date-picker>
                  </div>
                </div>
                <div class="flex-al mb20 mr10">
                  <span class="mr10 fs14 color-666">{{
                    $t("Crmactivemanage.ag")
                  }}</span>
                  <div class="select-box" style="width: 120px">
                    <el-select
                      filterable
                      v-model="selectForm.found_marketer_id"
                      class="mr15"
                      style="width: 120px"
                      clearable
                      :placeholder="$t('Crmactivemanage.ah')"
                      @change="handleSelect()"
                    >
                      <el-option
                        v-for="item in founder"
                        :key="item.marketer_id"
                        :label="`${item.marketer_name} ${
                          item.staffer_enname
                            ? '(' + item.staffer_enname + ')'
                            : ''
                        }`"
                        :value="item.marketer_id"
                      ></el-option>
                    </el-select>
                  </div>
                </div>
                <!-- 2020/01/20 需求 暂时隐藏 -->
                <!-- <div class="flex-al mb20 mr10">
                  <span class="mr10 fs14 color-666">{{
                    $t("Crmactivemanage.ai")
                  }}</span>
                  <div class="select-box" style="width: 120px">
                    <el-select
                      @change="handleSelect()"
                      v-model="selectForm.activity_pattern"
                      clearable
                      filterable
                      :placeholder="$t('Crmactivemanage.aj')"
                    >
                      <el-option
                        :label="$t('Crmactivemanage.ak')"
                        value
                      ></el-option>
                      <el-option
                        :label="$t('Crmactivemanage.al')"
                        value="0"
                      ></el-option>
                      <el-option
                        :label="$t('Crmactivemanage.am')"
                        value="1"
                      ></el-option>
                    </el-select>
                  </div>
                </div> -->
                <div class="flex-al mb20 mr10">
                  <span class="mr10 fs14 color-666">{{
                    $t("Crmactivemanage.an")
                  }}</span>
                  <div class="select-box" style="width: 120px">
                    <el-select
                      @change="frommediaSearch"
                      v-model="selectForm.frommedia_name"
                      clearable
                      filterable
                      :placeholder="$t('Crmactivemanage.ao')"
                    >
                      <el-option
                        :label="$t('Crmactivemanage.ak')"
                        value
                      ></el-option>
                      <el-option
                        v-for="item in SourceList"
                        :key="item.frommedia_id"
                        :label="item.frommedia_name"
                        :value="item.frommedia_name"
                      ></el-option>
                    </el-select>
                  </div>
                </div>
                <div class="flex-al mb20 mr10">
                  <span class="mr10 fs14 color-666">{{
                    $t("Crmactivemanage.ap")
                  }}</span>
                  <div class="select-box" style="width: 120px">
                    <el-select
                      @change="handleSelect()"
                      v-model="selectForm.channel_id"
                      clearable
                      filterable
                      :placeholder="$t('Crmactivemanage.aq')"
                    >
                      <el-option
                        :label="$t('Crmactivemanage.ak')"
                        value
                      ></el-option>
                      <el-option
                        v-for="item in ChannelList"
                        :key="item.channel_id"
                        :label="item.channel_name"
                        :value="item.channel_id"
                      ></el-option>
                    </el-select>
                  </div>
                </div>
                <div class="flex-al Inquire-box mb20">
                  <div class="ipt-box">
                    <el-input
                      clearable
                      :placeholder="$t('Crmactivemanage.ar')"
                      class="input-cont"
                      style="width: 200px"
                      v-model="selectForm.keyword"
                      @change="handleSelectKeyword()"
                    ></el-input>
                  </div>
                  <el-button
                    type="primary"
                    class="btn-inquire"
                    @click="handleSelectKeyword()"
                    >{{ $t("Crmactivemanage.as") }}</el-button
                  >
                </div>
              </div>
              <div class="tableList" ref="auto_height_table">
                <TableList
                  :list="tableData"
                  :options="optionscaozuo"
                  :columns="columns"
                  :operates="operates"
                  @handleCodeChange="handleCodeChange"
                  @handleColumnChange="handleColumnChange"
                ></TableList>
              </div>
              <el-pagination
                style="margin-top: 35px"
                @size-change="handleSizeChange"
                @current-change="handleCurrentChange"
                :current-page="currentPage"
                :page-sizes="[10, 20, 30, 40]"
                :page-size="pagesize"
                layout="total, sizes, prev, pager, next, jumper"
                :total="dataNumber"
              ></el-pagination>
            </div>
          </div>
        </div>
      </el-main>
    </PageNav>

    <!-- 二维码 -->
    <el-dialog
      :visible.sync="dialogVisible"
      class="tan-code clearFloat"
      width="500px"
      :before-close="handleCloseCode"
    >
      <div
        class="pull-right h1 btn-close font-333"
        style="cursor: pointer"
        @click="handleCloseCode"
      >
        <i class="el-icon-close"></i>
      </div>
      <div class="code">
        <div class="code-img">
          <div v-if="languageType == 'zh'" class="right">
            <p>活动名称：{{ onCodeInfo.title }}</p>
            <iframe
              v-if="onCodeInfo.oneCodeWxImg.indexOf('wework.qpic.cn') == -1"
              frameborder="0"
              :src="onCodeInfo.oneCodeWxImg"
              width="190"
              height="230"
            ></iframe>
            <img v-else-if="onCodeInfo.oneCodeWxImg" :src="onCodeInfo.oneCodeWxImg" width="100%" />
          </div>
        </div>
        <p class="h1">{{ codeName }}</p>
        <p class="h1">{{ $t("Crmactivemanage.av") }}</p>
      </div>
    </el-dialog>
    <!-- 地推 -->
    <SliderBox
      sliderWidth="500px"
      :showSliderBox="promotionVisible"
      @hideSliderBox="promotionVisible = false"
    >
      <div class="silder-contain promotion-drawer">
        <div class="slider-top clearFloat">
          <p class="h3 slider-title pull-left">地推二维码</p>
          <div class="pull-right flex-al">
            <el-button
              v-if="promotionList.length > 0"
              style="margin-top: 0"
              type="primary"
              size="small"
              @click="downloadPrmotion"
            >
              批量下载
            </el-button>
            <div
              class="h1 btn-close font-gray"
              @click="promotionVisible = false"
            >
              <i class="el-icon-close"></i>
            </div>
          </div>
        </div>
        <span class="promotion-tips">
          注：扫描地推二维码的名单进入招生有效名单，地推二维码仅作为名单录入人使用
        </span>
        <div class="promotion-area">
          <template v-if="promotionList.length > 0">
            <div
              class="promotion-list"
              v-for="(item, index) in promotionList"
              :key="index"
            >
              <!-- <img
                @click="onClickPromotionCode(item)"
                :src="item.personalQRcodeUrl"
              /> -->
              <!-- <div class="wx-ewm-box">
                <div
                  class="wx-ewm-mask"
                  @click="onClickPromotionCode(item)"
                ></div>
                <iframe
                  v-if="item.personalQRcodeUrl.indexOf('wework.qpic.cn') == -1"
                  frameborder="0"
                  :src="item.personalQRcodeUrl"
                  width="100%"
                  height="auto"
                ></iframe>
                <img
                  v-else
                  :src="item.personalQRcodeUrl"
                  width="90px"
                  class="mt15 ml5 mr5"
                />
              </div> -->
              <div>
                <div class="mb10">
                  <span>姓名：</span> {{ item.promotion_name }}
                </div>
                <div><span>联系电话：</span> {{ item.promotion_mobile }}</div>
              </div>
              <el-button
                type="primary"
                size="small"
                @click="onClickPromotionCode(item)"
              >
                地推二维码
              </el-button>
            </div>
          </template>
          <template v-else>
            <p class="no-data">
              <i class="mh-kym_icon"></i>
              {{ promotionErrorTip }}
            </p>
          </template>
        </div>
      </div>
    </SliderBox>
    <!-- 侧边新建栏 -->
    <SliderBox
      :showSliderBox="showSliderBoxCreate"
      @hideSliderBox="hideSliderBoxCreate"
      :sliderWidth="sliderWidth"
    >
      <activeTeamp
        :aciveInfo="aciveCreateInfo"
        :infomationData="infomationData"
        :showSliderBox="showSliderBoxCreate"
        @hideSliderBox="hideSliderBoxCreate"
        @onSubmit="onSubmit"
        @perviewTemp="perviewTemp"
        @handleAddClass="handleAddClass"
        @perviewSeeTemp="perviewSeeTemp"
        ref="activeTeampAdd"
      ></activeTeamp>
    </SliderBox>
    <!-- 编辑 -->
    <SliderBox
      :showSliderBox="showSliderBoxEdit"
      @hideSliderBox="hideSliderBoxEdit"
      :sliderWidth="sliderWidth"
    >
      <activeTeamp
        :aciveInfo="aciveEditInfo"
        :showSliderBox="showSliderBoxEdit"
        :isEdit="true"
        :infomationData="infomationData"
        @hideSliderBox="hideSliderBoxEdit"
        @onSubmit="onEditSubmit"
        @perviewTemp="perviewTempEdit"
        @perviewSeeTemp="perviewSeeTempEdit"
        @handleAddClass="handleAddClass"
        @handleRemoveClass="handleRemoveClass"
        ref="activeTeampEdit"
      ></activeTeamp>
    </SliderBox>

    <!-- 侧边查看栏 -->
    <!-- 侧边栏 -->
    <SliderBox
      :showSliderBox="showSliderBoxSee"
      @hideSliderBox="hideSliderBoxSee"
      :sliderWidth="sliderSeeWidth"
    >
      <div class="silder-contain slider-activitiesManage silder-contain-seeing">
        <div class="slider-top clearFloat">
          <p class="h3 slider-title pull-left">
            {{ activeOne.activity_pattern }}
          </p>
          <div
            class="pull-right h1 btn-close font-gray"
            @click="hideSliderBoxSee"
          >
            <i class="el-icon-close"></i>
          </div>
          <!-- && infomationData.activity_type != '1' -->
          <el-button
            type="primary"
            v-if="
              postbe_crmlevel == '1' ||
              (postbe_crmlevel == '3' &&
                infomationData.marketer_id == marketer_id)
            "
            class="pull-right"
            @click="handClickEdit()"
            >{{ $t("Crmactivemanage.ay") }}</el-button
          >
        </div>
        <div class="slider-cont text-1">
          <div class="active-cont">
            <!-- <iframe
              :src="`${infomationData.activity_PersonalUrl}&open_type=crm`"
              name="test"
              width="375"
              height="750"
              frameborder="1"
              align="left"
              scrolling="yes"
              @load="load"
            ></iframe> -->
            <img
              width="375"
              :src="infomationData.activitytemp_bannerimg"
              alt=""
            />
            <!-- <p class="info-title h3">{{infomationData.activity_name}}</p>
            <div
              class="info-small-title text-3 font-lightgray"
            >发布人：{{infomationData.marketer_name}}&nbsp;&nbsp;&nbsp;发布时间：{{infomationData.activity_createtime}}</div>
            <div class="info-content">
              <p class="text-1 text-content">{{infomationData.activity_content}}</p>
              <div class="info-img">
                <img v-bind:src="infomationData.activity_img" alt>
              </div>
              <div class="code">
                <img :src="infomationData.activity_appUrl" alt>
                <p class="h3">扫码分享活动</p>
              </div>
            </div>-->
          </div>
        </div>
      </div>
    </SliderBox>
    <!-- 活动模板预览图 -->
    <el-dialog
      :visible.sync="PreviewVisible"
      class="tan-Preview"
      width="500px"
      :before-close="handleClosePreview"
    >
      <div class="Preview-img">
        <img width="100%" :src="ActivitytempOne.activitytemp_styleimg_url" />
      </div>
    </el-dialog>
    <!-- 删除 -->
    <el-dialog
      :title="$t('Crmactivemanage.az')"
      :visible.sync="DelVisible"
      width="30%"
      :before-close="handleClose"
    >
      <div class="del-box">
        <div class="delTips tc">{{ $t("Crmactivemanage.ba") }}</div>
      </div>
      <span slot="footer" class="dialog-footer">
        <el-button @click="DelVisible = false">{{
          $t("Crmactivemanage.bb")
        }}</el-button>
        <el-button type="primary" @click="handleDelClickConfim()">{{
          $t("Crmactivemanage.bc")
        }}</el-button>
      </span>
    </el-dialog>
    <!-- 复制 -->
    <el-dialog
      :title="$t('Crmactivemanage.dialog_title')"
      :visible.sync="copyItem"
      width="30%"
      :before-close="handleClose"
    >
      <div class="del-box">
        <div class="delTips tc">{{ $t("Crmactivemanage.dialog_cont") }}</div>
      </div>
      <span slot="footer" class="dialog-footer">
        <el-button @click="copyItem = false">{{
          $t("Crmactivemanage.bb")
        }}</el-button>
        <el-button type="primary" @click="copyActivityOneApi()">{{
          $t("Crmactivemanage.bc")
        }}</el-button>
      </span>
    </el-dialog>

    <addSuitClass
      v-if="addSuitClassVisible"
      :addSuitClassVisible="addSuitClassVisible"
      :infomationData="infomationData"
      @handleCloseFrame="addSuitClassVisible = false"
      @handEditClassConfirm="handleSuitClassConfirm"
    ></addSuitClass>

    <el-dialog
      title="删除适用班种"
      :visible.sync="delSuitClass"
      width="30%"
      :before-close="handleClose"
    >
      <div class="del-box">
        <div class="delTips tc">确定删除适用班种吗？</div>
      </div>
      <span slot="footer" class="dialog-footer">
        <el-button @click="delSuitClass = false">{{
          $t("Crmactivemanage.bb")
        }}</el-button>
        <el-button type="primary" @click="delSetClassActionFun">{{
          $t("Crmactivemanage.bc")
        }}</el-button>
      </span>
    </el-dialog>
  </div>
</template>

<script>
import PageNav from "../../components/Nav/nav.vue";
import SliderBox from "../../components/SliderBox";
import TableList from "../../components/Table/table.vue";
import activeTeamp from "../../components/Activity/active.vue";
import CrmActiveManage from "../Crmactivemanage/crmActiveManage.js";
import addSuitClass from "../../components/Activity/addSuitClass.vue";
export default {
  name: "Activitiesmanage-activitiesManage",
  data() {
    return {
      codeName: "",
      marketer_id: "",
      addSuitClassVisible: false,
      delItem: "",
      delSuitClass: false,

      openMenu: ["1"],
      showSliderBoxCreate: false,
      showSliderBoxEdit: false,
      showSliderBoxSee: false,
      currentPage: 1,

      dialogVisible: false,
      PreviewVisible: false, //活动模板预览图
      DelVisible: false, //删除
      copyItem: false, //复制
      fullscreenLoading: true, //全屏loading
      goalId: "",
      onCodeInfo: {
        title: "",
        oneCodeImg: "", //单个活动的二维码
        oneCodeWxImg: "", //单个活动的二维码---微信
        oneCodeUrl: "", //单个活动的url
      },

      ActivitytempOne: {}, //单个模板信息
      // 分页的数据
      dataNumber: 0, //数据总数
      pagenum: "1",
      pagesize: 10,
      basicinformation: [],
      creatimageUrl: "",
      imageUrl: "",
      dialogimgVisible: false,
      input: "",
      select: "",
      sliderWidth: "850px",
      sliderSeeWidth: "450px",
      activeName: "first",
      activeName1: "first",
      activityId: "", //暂存查看的活动id
      activeOne: {}, //单个活动信息
      infoForm: {
        a_content: "",
        editorOption: {},
      },
      //富文本编辑器
      defaultMsg: this.$t("Crmactivemanage.bd"),
      config: {
        initialFrameWidth: null,
        initialFrameHeight: 350,
      },
      //筛选条件
      selectForm: {
        goal_starttime: "",
        goal_endtime: "",
        found_marketer_id: "",
        activity_pattern: "", //活动类型
        channel_id: "", //渠道明细
        frommedia_name: "", //渠道类型
        keyword: "",
      },
      //创建人
      founder: [],
      SourceList: [], //选择渠道类型-下拉数据
      ChannelList: [], //选择渠道明细-下拉数据
      // 发布活动
      aciveCreateInfo: {
        aciveText: this.$t("Crmactivemanage.be"),
        aciveClass: "silder-contain-creat",
      },
      // 编辑活动
      aciveEditInfo: {
        aciveText: this.$t("Crmactivemanage.bf"),
        aciveClass: "silder-contain-edit",
      },

      infomationData: {},

      columnWidth: ["200", "250", "200", "200", "200", "200", "auto"], //表格宽度
      // 表格数据
      tableData: [],
      optionscaozuo: {
        mutiSelect: false, // 是否支持列表项选中功能
        loading: true, //数据loading
        highlightCurrentRow: true, // 是否支持当前行高亮显示
        tableHeight: null, //表格高度
        errortip: "",
      },
      columns: [],
      operates: {
        width: 240,
        label: this.$t("Crmactivemanage.bg"),
        align: "center",
        fixed: "right",
        list: [
          {
            id: "1",
            label: this.$t("Crmactivemanage.bh"),
            type: "text",
            show: true,
            plain: true,
            disabled: false,
            method: (index, row) => {
              this.handleClick(row);
            },
          },
          {
            id: "2",
            label: this.$t("Crmactivemanage.bi"),
            type: "text",
            show: true,
            plain: true,
            is_active_del: true,
            disabled: false,
            method: (index, row) => {
              this.DelVisible = true;
              this.activityId = row.activity_id;
              this.activeOne = row;
            },
          },
          {
            id: "3",
            label: this.$t("Crmactivemanage.bj"),
            type: "text",
            show: true,
            plain: true,
            is_active_copy: true,
            disabled: false,
            jusdgeSpecialty: true, //是否判断专业版
            method: (index, row) => {
              this.activityId = row.activity_id;
              this.activeOne = row;
              this.copyItem = true;
            },
          },
          {
            id: "4",
            label: "地推二维码",
            type: "text",
            show: true,
            plain: true,
            disabled: false,
            promotion_qrcode: true,
            method: (index, row) => {
              this.activityId = row.activity_id;
              this.onCodeInfo.title = row.activity_name;
              this.handPromotion();
            },
          },
        ],
      }, // 列操作按钮
      defaultProps: {
        children: "children",
        label: "label",
      },
      // 表单验证
      rules: {
        activity_name: [
          {
            required: true,
            message: this.$t("Crmactivemanage.bk"),
            trigger: "blur",
          },
          {
            min: 2,
            max: 10,
            message: this.$t("Crmactivemanage.bl"),
            trigger: "blur",
          },
        ],
        activity_starttime: [
          {
            required: true,
            message: this.$t("Crmactivemanage.bm"),
            trigger: "change",
          },
        ],
        activity_endtime: [
          {
            required: true,
            message: this.$t("Crmactivemanage.bn"),
            trigger: "change",
          },
        ],
      },
      promotionVisible: false,
      promotionList: [],
      promotionErrorTip: "",
    };
  },
  components: {
    PageNav,
    SliderBox,
    // VueUeditorWrap,
    TableList,
    activeTeamp,
    addSuitClass,
  },
  updated() {
    this.fullscreenLoading = false;
  },
  created() {
    this.slider = this.$store.state.Slider;
    this.token = this.$store.state.USER_TOKEN;
    this.marketer_id = this.$store.state.MARKETER_ID;
    this.school_id = this.$store.state.SCHOOL_ID;
    this.company_id = this.$store.state.COMPANY_ID;
    this.postbe_crmuserlevel = this.$Tool.getStorage("PostbeCrmlevel")
      ? this.$Tool.getStorage("PostbeCrmlevel")
      : "";
    this.re_postbe_id = this.$Tool.getStorage("re_postbe_id")
      ? this.$Tool.getStorage("re_postbe_id")
      : "";
    this.language_type = this.$Tool.getStorage("language")
      ? this.$Tool.getStorage("language")
      : "";
    // 权限判断
    this.postbe_crmlevel = this.$store.state.POSTBE_CRMLEVEL;
    this.languageType = this.$Tool.getStorage("language")
      ? this.$Tool.getStorage("language")
      : "zh";

    this.getSellgoalData(this.pagenum);
    this.getActivityFounderData(); // 获取目标创建人管理
    this.getSourceApi(); // 获取渠道类型
    this.getChannelApi(); // 获取渠道明细
    // this.optionscaozuo.tableHeight = this.$Common.getTableHeight(310); //设置表格高度
  },
  computed: {
    editor() {
      return this.$refs.myQuillEditor.quill;
    },
  },
  methods: {
    load() {
      (() => {})("load");
    },
    downFile(url, filename) {
      const x = new XMLHttpRequest();
      x.open("GET", url, true);
      x.responseType = "blob";
      x.onload = () => {
        const url = window.URL.createObjectURL(x.response);
        const a = document.createElement("a");
        a.href = url;
        a.download = filename;
        a.click();
      };
      x.send();
    },
    // downloadImage(url, name) {
    //   fetch(url)
    //     .then(response => response.blob())
    //     .then(blob => {
    //       const blobUrl = URL.createObjectURL(blob);
    //       const a = document.createElement('a');
    //       a.href = blobUrl;
    //       a.download = 'qrcode.png';
    //       document.body.appendChild(a);
    //       a.click();
    //       document.body.removeChild(a);
    //       URL.revokeObjectURL(blobUrl); // 释放内存
    //     })
    //     .catch(error => console.error('下载失败:', error));
    // },
    downloadPrmotion() {
      this.promotionList.forEach((v) => {
        this.downFile(v.personalQRcodeUrl, `${v.promotion_name}.png`);
        // this.downloadImage(v.personalQRcodeUrl, v.promotion_name);
      });
    },
    handleAddClass() {
      (() => {})("addClass");
      this.addSuitClassVisible = true;
    },
    handleSuitClassConfirm(val) {
      let json = [];
      val.forEach((v) => {
        json.push({ coursecat_id: v.coursecat_id });
      });
      CrmActiveManage.batchActCoursecatAction({
        coursecat_json: JSON.stringify(json),
        activity_id: this.infomationData.activity_id,
        BatchType: "1", //1 适配 2取消适配
      }).then((res) => {
        (() => {})(res);
        if (res.data.code === 200) {
          this.$message({
            message: res.data.msg,
            type: "success",
          });
          this.addSuitClassVisible = false;
          if (this.$refs["activeTeampAdd"]) {
            this.$refs["activeTeampAdd"].ActivityCoursecatApi();
          }
          if (this.$refs["activeTeampEdit"]) {
            this.$refs["activeTeampEdit"].ActivityCoursecatApi();
          }
        } else {
          this.$message.error(res.data.msg);
        }
      });
    },
    handleRemoveClass(v) {
      var arr = [];
      var obj = {
        coursecat_id: v.coursecat_id,
      };
      arr.push(obj);
      this.delItem = [...arr];
      this.delSuitClass = true;
    },
    delSetClassActionFun() {
      CrmActiveManage.batchActCoursecatAction({
        coursecat_json: JSON.stringify(this.delItem),
        activity_id: this.infomationData.activity_id,
        BatchType: "2", //1 适配 2取消适配
      }).then((res) => {
        (() => {})(res);
        if (res.data.code === 200) {
          this.$message({
            message: res.data.msg,
            type: "success",
          });
          this.delSuitClass = false;
          if (this.$refs["activeTeampAdd"]) {
            this.$refs["activeTeampAdd"].ActivityCoursecatApi();
          }
          if (this.$refs["activeTeampEdit"]) {
            this.$refs["activeTeampEdit"].ActivityCoursecatApi();
          }
        } else {
          this.$message.error(res.data.msg);
        }
      });
    },

    // 我的招生活动管理
    getSellgoalData() {
      CrmActiveManage.getsellActivity({
        marketer_id: this.marketer_id,
        token: this.token,
        school_id: this.school_id,
        company_id: this.company_id,
        is_count: "1", //是否需要总数，可以不传
        p: this.currentPage,
        num: this.pagesize,
        //筛选条件
        activity_starttime: this.selectForm.goal_starttime,
        activity_endtime: this.selectForm.goal_endtime,
        activity_pattern: this.selectForm.activity_pattern,
        found_marketer_id: this.selectForm.found_marketer_id,
        frommedia_name: this.selectForm.frommedia_name,
        channel_id: this.selectForm.channel_id,
        keyword: this.selectForm.keyword,
      }).then((res) => {
        const { code, data: _jb } = res.data;

        const data = _jb;

        let list = code === 200 ? data.list : [];

        this.tableData = list;

        this.dataNumber = res.data.data.allnum;

        var Columns = res.data.data.field;

        Columns.forEach((item) => {
          if (
            item.fieldname == "qrcode" ||
            item.fieldname == "personalqrcode"
          ) {
            item.isWxCode = 1;
          }
        });

        this.columns = this.$Common.handleTable(
          Columns,
          this.columnWidth,
          true,
          0
        );

        (() => {})(this.columns, "this.columns");

        this.optionscaozuo.loading = false;
        if (res.data.code !== 200) {
          this.optionscaozuo.errortip = res.data.msg;
        }
      });
    },
    // 获取渠道类型
    getSourceApi() {
      this.$http
        .getSourceApi({
          staffer_id: this.staffer_id,
          company_id: this.company_id,
          token: this.token,
        })
        .then((res) => {
          this.SourceList = res.data.data.list;
        });
    },
    // 获取渠道明细
    getChannelApi() {
      this.$http
        .getChannelApi({
          staffer_id: this.staffer_id,
          company_id: this.company_id,
          token: this.token,
          channel_medianame: this.selectForm.frommedia_name,
        })
        .then((res) => {
          this.ChannelList = res.data.data.list;
        });
    },
    // 选择查询
    handleSelect() {
      this.currentPage = 1;
      this.getSellgoalData(this.pagenum);
    },
    // 招生渠道类型筛选
    frommediaSearch() {
      this.currentPage = 1;
      this.selectForm.channel_id = "";
      this.getChannelApi(); // 获取渠道明细
      this.getSellgoalData(this.pagenum);
    },
    // 输入关键词查询
    handleSelectKeyword() {
      this.currentPage = 1;
      this.getSellgoalData(this.pagenum);
    },
    // 复制活动
    copyActivityOneApi() {
      CrmActiveManage.copyActivityOneApi({
        marketer_id: this.marketer_id,
        token: this.token,
        school_id: this.school_id,
        company_id: this.company_id,
        activity_id: this.activityId,
      }).then((res) => {
        (() => {})(res);
        if (res.data.code === 200) {
          this.$message({
            message: res.data.msg,
            type: "success",
          });
          this.copyItem = false;
          this.getSellgoalData(this.pagenum);
        } else {
          this.$message({
            message: res.data.msg,
            type: "error",
          });
        }
      });
    },
    handPromotion() {
      CrmActiveManage.GroundPromotionQRcodeApi({
        activity_id: this.activityId,
      }).then((res) => {
        const { code, msg, data: body } = res.data;

        if (code === 200) {
          this.promotionList = body.list;
        } else {
          this.promotionList = [];
        }
        this.promotionErrorTip = msg;
        this.promotionVisible = true;
      });
    },
    // 获取目标创建人管理
    getActivityFounderData() {
      CrmActiveManage.getActivityFounder({
        marketer_id: this.marketer_id,
        token: this.token,
        school_id: this.school_id,
        company_id: this.company_id,
      }).then((res) => {
        this.founder = res.data.data.data;
      });
    },
    //单个招生活动查看
    getgoalActivityOneData(id) {
      CrmActiveManage.getgoalActivityOne({
        marketer_id: this.marketer_id,
        token: this.token,
        school_id: this.school_id,
        company_id: this.company_id,
        activity_id: id, //活动 id
      }).then((res) => {
        this.infomationData = { ...res.data.data.data };
      });
    },
    // 点击名字查看单个员工
    handleColumnChange(k, v) {
      (() => {})(v, k);
      this.onCodeInfo.title = v.activity_name;
      this.activityId = v.activity_id;
      this.activeOne = v;
      this.showSliderBoxSee = true;
      this.getgoalActivityOneData(v.activity_id);
    },
    // 点击查看里的编辑
    handClickEdit() {
      this.showSliderBoxSee = false;
      this.showSliderBoxEdit = true;
    },
    // 确定删除
    handleDelClickConfim() {
      // 删除招生活动
      CrmActiveManage.delGoalActivity({
        marketer_id: this.marketer_id,
        token: this.token,
        school_id: this.school_id,
        company_id: this.company_id,
        activity_id: this.activityId,
      }).then((res) => {
        (() => {})(res);
        if (res.data.code === 200) {
          this.showSliderBoxEdit = false;
          this.$message({
            message: res.data.msg,
            type: "success",
          });
          this.getSellgoalData(this.pagenum);
          this.DelVisible = false;
        } else {
          this.$message({
            message: res.data.msg,
            type: "error",
          });
        }
      });
    },
    onEditorReady(editor) {
      (() => {})(editor);
    },
    // 预览模版******新建
    perviewTemp(v) {
      this.PreviewVisible = true;
      v.activitytemp_styleimg_url = v.activitytemp_styleimg;
      this.ActivitytempOne = v;
    },
    // 查看预览图******新建
    perviewSeeTemp(v) {
      this.PreviewVisible = true;
      v.activitytemp_styleimg_url = v.activitytemp_bannerimg;
      this.ActivitytempOne = v;
    },
    // 预览模版******编辑
    perviewTempEdit(v) {
      this.PreviewVisible = true;
      v.activitytemp_styleimg_url = v.activitytemp_styleimg;
      this.ActivitytempOne = v;
    },
    // 查看预览图******编辑
    perviewSeeTempEdit(v) {
      this.PreviewVisible = true;
      v.activitytemp_styleimg_url = v.activitytemp_bannerimg;
      this.ActivitytempOne = v;
    },
    // 关闭活动模板预览图
    handleClosePreview() {
      this.PreviewVisible = false;
    },
    hideSliderBoxCreate() {
      this.showSliderBoxCreate = false;
    },
    hideSliderBoxEdit() {
      this.showSliderBoxEdit = false;
    },
    hideSliderBoxSee() {
      this.showSliderBoxSee = false;
    },
    handleDel() {
      this.dialogVisible = true;
    },
    //发布招生活动
    onSubmit(v) {
      // 添加招生活动
      CrmActiveManage.addGoalActivity(v).then((res) => {
        (() => {})(res);
        const { code, msg, data: body } = res.data;
        if (code === 200) {
          this.getSellgoalData(this.pagenum);
          this.getgoalActivityOneData(body.activity_id);
          this.$message({
            message: msg,
            type: "success",
          });
          // this.showSliderBoxCreate = false;
        } else {
          this.$message({
            message: msg,
            type: "error",
          });
        }
      });
    },
    //编辑招生活动提交
    onEditSubmit(v) {
      let data = v;
      data.activity_id = this.activityId;
      // 修改招生活动
      CrmActiveManage.updateGoalActivity(data).then((res) => {
        (() => {})(res);
        if (res.data.code === 200) {
          this.showSliderBoxCreate = false;
          this.$message({
            message: res.data.msg,
            type: "success",
          });
          this.getSellgoalData(this.pagenum);
          this.showSliderBoxEdit = false;
        } else {
          this.$message({
            message: res.data.msg,
            type: "error",
          });
        }
      });
    },
    changeSize() {
      (() => {})("change");
    },
    handleSliderClick(tab, event) {
      (() => {})(tab, event);
    },
    handleSliderSeeClick(tab, event) {
      (() => {})(tab, event);
    },
    handleClick(v) {
      this.showSliderBoxSee = true;
      (() => {})(v);
      this.activityId = v.activity_id;
      this.activeOne = v;
      this.getgoalActivityOneData(v.activity_id);
    },
    handleCreateClick() {
      this.infomationData = {};
      this.showSliderBoxCreate = true;
    },
    handleClose(done) {
      this.$confirm(this.$t("Crmactivemanage.bo"))
        .then((_) => {
          (() => {})(_);
          done();
        })
        .catch((_) => {
          (() => {})(_);
        });
    },
    handleCloseCode() {
      this.onCodeInfo.oneCodeImg = ''
      this.onCodeInfo.oneCodeWxImg = ''
      this.onCodeInfo.oneCodeUrl = ''
      this.dialogVisible = false;
    },
    handleSizeChange(val) {
      (() => {})(`每页 ${val} 条`);
      this.pagesize = val;
      this.getSellgoalData(this.pagenum);
    },
    handleCurrentChange(val) {
      (() => {})(`当前页: ${val}`);
      this.currentPage = val;
      this.getSellgoalData(val);
    },
    //点击查看二维码
    handleCodeChange(k, v, col) {
      this.onCodeInfo.title = v.activity_name;
      this.onCodeInfo.oneCodeImg = ''
      this.onCodeInfo.oneCodeWxImg = ''
      this.onCodeInfo.oneCodeUrl = ''
      if (col.isschool == "1") {
        this.onCodeInfo.oneCodeImg = v.qrcode; //学校二维码
        this.onCodeInfo.oneCodeWxImg = v.QRcodeUrl; //学校二维码
        this.onCodeInfo.oneCodeUrl = v.qrcodeurl;
        this.codeName = v.now_school_cnname;
      } else {
        this.onCodeInfo.oneCodeImg = v.personalqrcode; //个人二维码
        this.onCodeInfo.oneCodeWxImg = v.personalQRcodeUrl; //个人二维码
        this.onCodeInfo.oneCodeUrl = v.personalqrcodeurl;
        this.codeName = v.now_marketer_name;
      }
      this.dialogVisible = true;
    },
    onClickPromotionCode(v) {
      this.dialogVisible = true;
      this.codeName = v.promotion_name
      this.onCodeInfo.oneCodeImg = v.personalqrcode; //个人二维码
      this.onCodeInfo.oneCodeWxImg = v.personalQRcodeUrl; //个人二维码
      this.onCodeInfo.oneCodeUrl = v.personalqrcodeurl;
    },
    // 导出操作
    daochu() {
      let params_str = "",
        is_export = 1;
      for (let name in this.selectForm) {
        if (name != "rang_time") {
          // 时间范围不需要
          params_str = params_str + `&${name}=${this.selectForm[name]}`;
        }
      }
      let url = CrmActiveManage.getsellActivity1();
      params_str = `${url}?marketer_id=${this.marketer_id}&token=${this.token}&school_id=${this.school_id}&company_id=${this.company_id}&re_postbe_id=${this.re_postbe_id}&postbe_crmuserlevel=${this.postbe_crmuserlevel}&language_type=${this.language_type}&is_export=${is_export}${params_str}`;
      (() => {})(params_str);
      if (this.tableData.length > 0) {
        window.open(this.$buildExportUrl(params_str), "_blank");
      } else {
        this.$message.error(this.$t("Common.exportTips"));
      }
    },
  },
  mounted() {
    this.$nextTick(() => {
      if (this.$refs["auto_height_table"]) {
        this.optionscaozuo.tableHeight = this.$Common.getTableHeight(
          this.$refs.auto_height_table.getBoundingClientRect().top + 110
        );
      }
    });
  },
};
</script>

<style lang="less">
@import url("../../assets/less/manage.less");
@import url("crmActiveManage.less");

.activitiesManage {
  height: 100vh;
  font-size: 20px;
  .code-img {
    width: 100%;
    display: flex;
    justify-content: space-between;
    > div {
      flex: 1;
      img {
        width: 165px !important;
        height: 165px;
      }
    }
    .left {
      // margin-right: 10px;
      .one-img {
        width: 220px;
        height: 220px;
        padding-top: 13px;
      }
      .one-tw-img {
        width: 300px;
        height: 300px;
        margin: 0 auto;

        img {
          width: 100% !important;
          height: 100%;
        }
      }
    }
    .right {
      // margin-left: 10px;
    }
    iframe {
      * {
        margin: 0 !important;
        padding: 0 !important;
      }
    }
  }
}
.promotion-drawer {
  height: 100%;
  .promotion-tips {
    display: inline-block;
    color: #f46c6c;
    font-size: 12px;
    margin: 20px;
  }
  .promotion-list {
    width: 448px;
    height: 118px;
    border-radius: 6px;
    border: 1px solid #e5e6e6;
    margin-bottom: 12px;
    margin-left: 24px;
    padding: 0 24px;
    display: flex;
    align-items: center;
    justify-content: space-between;
    > img {
      width: 80px;
      height: 80px;
      margin-left: 25px;
      margin-right: 45px;
      cursor: pointer;
    }
    > div {
      font-size: 14px;
      font-weight: 400;
      color: #333333;
      display: flex;
      flex-direction: column;
    }
  }
  .no-data {
    margin-top: 100px;
    color: #999999;
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: center;
    font-size: 14px;
    i {
      display: inline-block;
      font-size: 40px;
      margin-bottom: 20px;
    }
    i:before {
      color: #999999;
    }
  }
}

.wx-ewm-box {
  width: 100px;
  height: 120px;
  position: relative;

  ::-webkit-scrollbar {
    display: none;
  }

  .wx-ewm-mask {
    position: absolute;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
    z-index: 1;
  }
}
</style>
